<template>
  <div>
		<SQLReport v-model="selectedReport" :listFormatters="listFormatters" :listTitles="listTitles">
		<!-- <SQLReport v-model="selectedReport" > -->
      <p>** Note: takes 10-15 seconds to load data.</p>
      <p>FYI: Terminal ID 61001560 is WGB, 61030688 is RMGB proper</p>
		</SQLReport>
  </div>
</template>

<script>
import sqlReports from '../SQLReports/components/sqlReports.js'
import SQLReport from '../SQLReports/components/SQLReport.vue'

export default {
	name:'ManualTransactions',
	components: {SQLReport},
  data () {return {
    selectedReport: sqlReports.pos_manual_transactions,
    listFormatters: {
      'month': ['d', 'YYYY MMM'],
      'settlement_date': ['d', 'YYYY-MM-DD'],
      'batch_number': ['n', '0'],
      'settled_amount': ['n', '0,0.00'],
      'amount': ['n', '0,0.00'],
    },
    listTitles: {
      'group' : 'Location',
      'device_number' : 'Terminal ID',
      'vid' : 'Vehicle',
    },

  }},
  created () {
    // this.loadData()
  },
  methods:{
  }
  
}
</script>

<style>

</style>
